import { Translation } from '../services/language-service.service';

export class GameAnswerObject{

  public image: string;
  public content: {
    EASY: Translation,
    MED: Translation,
    HARD: Translation
  };
  public tooSimilar: string[];    // NOTE: tooSimilar contains strings that equal content.Easy.fi

  constructor(json?: any){
    if (!!json) {
      this.image = json.image;
      this.content = json.content;
      this.tooSimilar = json.tooSimilar;
    }
  }

  public Copy(): GameAnswerObject {
    const retVal = new GameAnswerObject();
    retVal.image = this.image;
    retVal.content.EASY = {...this.content.EASY};
    retVal.content.MED = {...this.content.MED};
    retVal.content.HARD = {...this.content.HARD};
    retVal.tooSimilar = [...this.tooSimilar];
    return retVal;
  }

  public Equals(compare: GameAnswerObject): boolean {
    return this.image === compare.image && this.content.EASY.fi === compare.content.EASY.fi;
  }

  public IsTooSimilar(compare: GameAnswerObject): boolean {
    return this.tooSimilar.includes(compare.content.EASY.fi) || compare.tooSimilar.includes(this.content.EASY.fi);
  }

}
